export const ONQ = "OnQ";
export const PMS_ALL_VALUE = "all";

export const pmsBasedFileMappingCondition = (pms) => {
  if (pms === ONQ) {
    return "Exact";
  }
  if (pms === PMS_ALL_VALUE) {
    return undefined;
  }
  return "Contains";
};

export default {
  ONQ,
  PMS_ALL_VALUE,
  pmsBasedFileMappingCondition,
};
